import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilService } from './util.service';
import { LoaderService } from './loader.service';

@Injectable()
export class ReportsService {

  constructor(
    private http: HttpService, 
    private utilService: UtilService,
    private loaderService: LoaderService
    ) { }

    getGeneratedReport(data) {
      return this.http.post(`/reportgeneration/generacion`, data)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }

    getExchangeReport(data) {
      return this.http.post(`/reportgeneration/canje`, data)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/_services/reports.service.ts